import { WuiMainNav } from '@jwplayer/wui-react';

import { UiStore } from '/global-state/ui';
import { getAnchorProps } from '/module/routing/module';

import { useNavigation } from './hooks';
import { PropertySelector } from './site-switcher';

export const MainNav = () => {
  const { navigation, bottomDrawer, isCollapsed, hideSiteSwitch } = useNavigation();

  return (
    <WuiMainNav
      navigation={!hideSiteSwitch ? navigation : []}
      bottomDrawer={!hideSiteSwitch ? bottomDrawer : []}
      collapsed={isCollapsed}
      onCollapseChanged={(e) => {
        UiStore.setState((s) => {
          s.sideNavCollapsed = e.detail;
        });
      }}
      collapsible={!hideSiteSwitch}
      logoLink={{ label: 'Home', icon: 'home', ...getAnchorProps('home') }}
    >
      {!hideSiteSwitch && (
        <section slot="top-content">
          <PropertySelector />
        </section>
      )}
    </WuiMainNav>
  );
};
